import { Helpers } from '../../helpers';
import { IWaterType } from '../../interfaces/iwater-type';
import { ProjectPondParameter } from '../project-pond-parameter';

export class WaterTypeBase {
  WaterTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ProjectPondParameters_WaterType?: Array<ProjectPondParameter> | null;

  constructor(item?: IWaterType) {
    if (item) {
      this.WaterTypeId = item.WaterTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ProjectPondParameters_WaterType = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_WaterType);

    }
  }
}